import { set, setErrors } from '@/utils/vuex'

export default {
  setLoading: set('loading'),
  setErrors: setErrors(),
  setCountryCodesLoading: set('countryCodesLoading'),
  setCountryCodes: set('countryCodes')
}
